import { render, staticRenderFns } from "./TableauRecord3.vue?vue&type=template&id=6a95a1bf"
import script from "./TableauRecord3.vue?vue&type=script&lang=js"
export * from "./TableauRecord3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports